import { IOneDriveItemInfo } from './interfaces/IOneDriveItem';

export function ParseItemInfoFromGraphResponse(response: any): IOneDriveItemInfo {
    if (response == null)
        throw new Error('Invalid response passed to ParseItemInfoFromGraphResponse');

    if (response.name == null || response.webUrl == null)
        throw new Error('Response does not contain all required fields');

    return {
        name: response.name,
        webUrl: response.webUrl,
        downloadUrl: response['@microsoft.graph.downloadUrl']
    };
}